import {
  Box,
  createTheme,
  Grid2,
  Link,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { EmailOutlined } from "@mui/icons-material";

function Footer() {
  const theme = createTheme({
    components: {
      MuiTypography: {
        variants: [
          {
            props: { variant: "body2" },
            style: { fontSize: 12 },
          },
        ],
      },
    },
  });

  return (
    <Grid2 spacing={3} sx={{ p: 4 }} component="footer" className="footer">
      <Stack
        sx={(theme) => ({
          [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          },
          [theme.breakpoints.up("sm")]: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          },
        })}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <EmailOutlined sx={{ width: 16 }} />
          <Typography
            variant="body2"
            component="a"
            href="mailto:info@pgroots.in"
            color="inherit"
            marginLeft={0.5}
            sx={{ textDecoration: "none" }}
          >
            info@pgroots.in
          </Typography>
        </Box>
        <ThemeProvider theme={theme}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Link
              href="https://www.facebook.com/pgrootshq"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                // "&:hover": {
                //   color: "#1877F2", // new color on hover
                // },
                marginRight: 3,
              }}
            >
              <FacebookIcon />
            </Link>
            <Link
              href="https://x.com/pgrootshq"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                // "&:hover": {
                //   color: "#1DA1F2", // new color on hover
                // },
                marginRight: 3,
              }}
            >
              <XIcon fontSize="small" />
            </Link>
            <Link
              href="https://www.instagram.com/pgrootshq"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                // "&:hover": {
                //   color: "#E4405F", // new color on hover
                // },
                marginRight: 3,
              }}
            >
              <InstagramIcon fontSize="small" />
            </Link>
            {/* <Link
              href="https://x.com/ThePgroots"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                // "&:hover": {
                //   color: "#0A66C2", // new color on hover
                // },
                marginRight: 3,
              }}
            >
              <LinkedInIcon />
            </Link> */}
            {/* <Link
              href="https://x.com/ThePgroots"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                // "&:hover": {
                //   color: "#FF0000", // new color on hover
                // },
              }}
            >
              <YouTubeIcon sx={{ marginRight: 3 }} />
            </Link> */}
            <CopyrightIcon sx={{ width: 14 }} />
            <Typography variant="body2" component="p" marginLeft={0.5}>
              2026 Pgroots
            </Typography>
          </Box>
        </ThemeProvider>
      </Stack>
    </Grid2>
  );
}

export default Footer;
